import React from 'react';
import { Column } from 'new/elements/Table/types';
import { User } from 'new/entities/User';
import { TableProfile } from 'new/elements/TableProfile';
import { ChipBadge } from 'new/elements/ChipBadge';
import {
  getUserRoleLabel,
  USER_ROLE_ADMIN,
  USER_ROLE_OPERATOR,
  USER_ROLE_COLLABORATOR,
  USER_ROLE_MEMBER,
} from 'js/constants/userRoles';

const roleFilterOptions = [
  { label: getUserRoleLabel(USER_ROLE_ADMIN), value: USER_ROLE_ADMIN },
  { label: getUserRoleLabel(USER_ROLE_OPERATOR), value: USER_ROLE_OPERATOR },
  {
    label: getUserRoleLabel(USER_ROLE_COLLABORATOR),
    value: USER_ROLE_COLLABORATOR,
  },
  { label: getUserRoleLabel(USER_ROLE_MEMBER), value: USER_ROLE_MEMBER },
];

export const columns = [
  {
    name: 'Name',
    field: 'full_name',
    sortable: true,
    renderRow(row) {
      return <TableProfile name={row.full_name} />;
    },
  },
  {
    name: 'Role',
    field: 'access_role',
    renderRow(row) {
      return getUserRoleLabel(row.access_role);
    },
    filterable: true,
    filterOptions: roleFilterOptions,
  },
  {
    name: 'Status',
    field: 'org_membership_status',
    filterable: true,
    filterOptions: [
      { label: 'Active', value: 'ACTIVE', default: true },
      { label: 'Deactivated', value: 'DEACTIVATED' },
    ],
    renderRow(row) {
      const effectiveStatus = row.org_membership_status || 'ACTIVE';
      const isActive = effectiveStatus === 'ACTIVE';
      return (
        <ChipBadge
          dot
          color={isActive ? 'success' : 'disabled'}
          label={isActive ? 'Active' : 'Deactivated'}
        />
      );
    },
  },
  {
    name: 'Email address',
    field: 'email',
    sortable: true,
  },
] as Column<User>[];
